// Node.js 版本的 svg2Base64 工具函数

const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
const PREFIX = 'data:image/svg+xml;base64,';

const utf8Encode = (string: string) => {
  string = string.replace(/\r\n/g, '\n');
  let utftext = '';

  for (let n = 0; n < string.length; n++) {
    const c = string.charCodeAt(n);

    if (c < 128) {
      utftext += String.fromCharCode(c);
    } else if (c > 127 && c < 2048) {
      utftext += String.fromCharCode((c >> 6) | 192);
      utftext += String.fromCharCode((c & 63) | 128);
    } else {
      utftext += String.fromCharCode((c >> 12) | 224);
      utftext += String.fromCharCode(((c >> 6) & 63) | 128);
      utftext += String.fromCharCode((c & 63) | 128);
    }
  }

  return utftext;
};

const encode = (input: string) => {
  let output = '';
  let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
  let i = 0;
  input = utf8Encode(input);
  while (i < input.length) {
    chr1 = input.charCodeAt(i++);
    chr2 = input.charCodeAt(i++);
    chr3 = input.charCodeAt(i++);
    enc1 = chr1 >> 2;
    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
    enc4 = chr3 & 63;
    if (isNaN(chr2)) enc3 = enc4 = 64;
    else if (isNaN(chr3)) enc4 = 64;
    output = output + characters.charAt(enc1) + characters.charAt(enc2) + characters.charAt(enc3) + characters.charAt(enc4);
  }
  return output;
};

// Node.js 版本：直接处理 SVG 字符串而不是 DOM 元素
export const svg2Base64 = (svgString: string) => {
  return PREFIX + encode(svgString);
};

// 从 SVG 元素对象生成 SVG 字符串（用于特殊形状和 LaTeX）
export const generateSvgString = (element: any): string => {
  // 这里需要根据实际的数据结构来生成 SVG 字符串
  // 由于我们没有 DOM，我们需要从元素数据中构建 SVG

  if (element.special) {
    // 特殊形状：从元素数据生成 SVG
    return generateSpecialShapeSvg(element);
  } else if (element.type === 'latex') {
    // LaTeX：从元素数据生成 SVG
    return generateLatexSvg(element);
  }

  return '';
};

const generateSpecialShapeSvg = (element: any): string => {
  // 基于实际数据结构生成特殊形状的 SVG
  const width = element.width || 100;
  const height = element.height || 100;
  const viewBox = element.viewBox || [100, 100];
  const path = element.path || '';
  const fill = element.fill || '#000000';

  // 检查是否有有效的路径数据
  if (!path || path.trim() === '') {
    console.warn('Special shape has no valid path data:', element.id);
    return '';
  }

  // 检查尺寸是否有效（模拟原始代码的检查逻辑）
  if (width < 1 || height < 1) {
    console.warn('Special shape has invalid dimensions:', element.id, 'width:', width, 'height:', height);
    return '';
  }

  return `<svg width="${width}" height="${height}" viewBox="0 0 ${viewBox[0]} ${viewBox[1]}" xmlns="http://www.w3.org/2000/svg">
    <path d="${path}" fill="${fill}"/>
  </svg>`;
};

const generateLatexSvg = (element: any): string => {
  // 基于实际数据结构生成 LaTeX 的 SVG
  const width = element.width || 100;
  const height = element.height || 100;
  const viewBox = element.viewBox || [100, 100];
  const path = element.path || '';
  const color = element.color || '#000000';
  const strokeWidth = element.strokeWidth || 1;
  const latex = element.latex || '';

  // 检查是否有有效的路径数据
  if (!path || path.trim() === '') {
    console.warn('LaTeX element has no valid path data:', element.id);
    return '';
  }

  // 检查尺寸是否有效（模拟原始代码的检查逻辑）
  if (width < 1 || height < 1) {
    console.warn('LaTeX element has invalid dimensions:', element.id, 'width:', width, 'height:', height);
    return '';
  }

  return `<svg width="${width}" height="${height}" viewBox="0 0 ${viewBox[0]} ${viewBox[1]}" xmlns="http://www.w3.org/2000/svg">
    <path d="${path}" stroke="${color}" stroke-width="${strokeWidth}" fill="none"/>
  </svg>`;
};
